export default __webpack_public_path__ + "static/media/type.5e425fa3.svg";